import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)
Vue.config.productionTip = false



//使用钩子函数解析路由
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')



